import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("taven_admin_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch {
      toast.error("Invalid email or password");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-taven-black p-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="bg-white w-full max-w-sm p-8">
        <div className="text-center mb-6">
          <div className="w-12 h-12 bg-taven-gold/15 flex items-center justify-center mx-auto"><Lock className="w-5 h-5 text-taven-gold" /></div>
          <h1 className="text-2xl font-black font-display mt-3">TAVEN Admin</h1>
          <p className="text-xs text-muted-foreground">Internal dashboard access</p>
        </div>
        <input required type="email" placeholder="Email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-black/15 focus:border-taven-gold outline-none px-4 py-3 text-sm mb-3" />
        <input required type="password" placeholder="Password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-black/15 focus:border-taven-gold outline-none px-4 py-3 text-sm mb-4" />
        <button disabled={loading} data-testid="admin-login-submit" className="w-full bg-taven-black text-white font-bold uppercase tracking-wider py-3.5 hover:bg-taven-orange transition-colors disabled:opacity-60">{loading ? "Signing in..." : "Sign In"}</button>
      </form>
    </div>
  );
};

export default AdminLogin;
